module.exports = __webpack_public_path__ + "static/media/results.78bd6c8e.png";